import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AbConfigZonas } from 'app/abstract/full-pages/config-scond-key/config-zonas.abstract';
import { ConfigZonasGrupos } from 'app/models/config-zonas-grupos.model';
import { ConfigZonasArea } from 'app/models/config-zonas-area.model';



@Injectable({ providedIn: 'root' })
export class ConfigZonasService extends AbConfigZonas {
  prefixo: String = "config_zonas_area"

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllConfigZonas(): Observable<any> {
    return this.get(`config_zonas_area/all/dto`);
  }

  public getAllConfigZonasPromise() {
    return this.get(`config_zonas_area/all/dto`).toPromise();
  }

  public getAllConfigZonasGrupos() {
    return this.get(`config_zonas_grupos/all/dto`)
  }

  public saveConfigsZonasGrupos(configZonasArea: Array<ConfigZonasGrupos>) {
    return this.save(`config_zonas_grupos/savelist`, configZonasArea);
  }

  public saveConfigsZonas(configZonasArea: Array<ConfigZonasArea>): Observable<any> {
    return this.save(`${this.prefixo}/savelist`, configZonasArea);
  }

  public getZonas(configZonasId: number, tipo: string): Observable<any> {
    return this.get(`${this.prefixo}/integracao/${configZonasId}/zonas`, null, {
      tipo: tipo
    })
  }

  public salvarZonas(payload: ConfigZonasArea) {
    return this.post(`${this.prefixo}/integracao/zonas`, payload);
  }
}
